<template>
  <layout>
    <div class="section">
      <div class="content">
        <div class="verify-section">
          <div class="row">
            <div class="name">邮箱：</div>
            <div>{{ info.email }}</div>
          </div>
          <div class="row">
            <div class="name">认证状态：</div>
            <div>{{ info.verifyStatus | verifyStatus }}</div>
          </div>
          <div class="row">
            <div class="name">说明：</div>
            <div>{{ info.message }}</div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>
<script>
import layout from "./components/layout.vue";
import { userVerifyEmail } from "api/user.js";
export default {
  name: "emailc",
  components: {
    layout,
  },
  filters: {
    verifyStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      info: {},
    };
  },
  created() {
    if (!this.$route.query.key) {
      this.$Message.warning("认证秘钥,不存在请获取密钥！");
      return false;
    }
    this.req_userVerifyEmail();
  },
  methods: {
    req_userVerifyEmail() {
      const parms = {
        key: this.$route.query.key,
      };
      userVerifyEmail(parms).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.info = data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 210px 0 80px;
  .content {
    width: 1200px;
    margin: 0 auto;
  }
}
.verify-section {
  width: 400px;
  height: 400px;
  margin: 0 auto;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .name {
    min-width: 80px;
    font-size: 18px;
    line-height: 30px;
    color: #333;
  }
  .name.required {
    &::before {
      content: "*";
      color: #ed1d33;
      margin-right: 5px;
    }
  }
  .label {
    font-size: 18px;
    line-height: 30px;
    color: #333;
  }
}
</style>
